import styles from "./IlluCalendar.module.css";

export function IlluCalendar() {
  return (
    <svg id="Calque_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
      <path
        className={styles.cls1}
        d="M79.18,219.52v5.97h158.43V91.14h-33.29c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78h-31.89c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78h-29.9c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78h-32.94c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78h-32.59c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78h-19.42v134.34h17.38"
      />
      <polyline
        className={styles.cls1}
        points="237.61 120.09 217.15 120.09 194.16 120.09 171.16 120.09 148.17 120.09 125.17 120.09 102.18 120.09 79.18 120.09 56.19 120.09 35.73 120.09"
      />
      <line className={styles.cls1} x1="35.73" y1="111.37" x2="237.61" y2="111.37" />
      <polyline
        className={styles.cls1}
        points="56.19 120.09 56.19 196.95 56.19 203.55 56.19 223.87 56.19 225.48"
      />
      <polyline
        className={styles.cls1}
        points="79.18 225.48 79.18 219.52 79.18 208.03 79.18 201.42 79.18 150.77"
      />
      <line className={styles.cls1} x1="79.18" y1="137.01" x2="79.18" y2="120.09" />
      <polyline
        className={styles.cls1}
        points="102.18 225.48 102.18 218.16 102.18 208.03 102.18 201.42 102.18 194.96"
      />
      <polyline className={styles.cls1} points="102.18 169.43 102.18 167.89 102.18 120.09" />
      <polyline
        className={styles.cls1}
        points="125.17 120.09 125.17 185.46 125.17 192.07 125.17 216.8 125.17 225.48"
      />
      <polyline
        className={styles.cls1}
        points="148.17 120.09 148.17 185.46 148.17 192.07 148.17 215.48 148.17 225.48"
      />
      <polyline
        className={styles.cls1}
        points="171.16 161.11 171.16 167.89 171.16 174.51 171.16 181.49"
      />
      <polyline className={styles.cls1} points="171.16 225.48 171.16 214.17 171.16 195.25" />
      <line className={styles.cls1} x1="171.16" y1="135.58" x2="171.16" y2="120.09" />
      <polyline
        className={styles.cls1}
        points="194.16 120.09 194.16 201.42 194.16 208.03 194.16 212.91 194.16 225.48"
      />
      <polyline
        className={styles.cls1}
        points="217.15 225.48 217.15 211.67 217.15 208.03 217.15 201.42 217.15 184.8 217.15 178.19 217.15 170.27 217.15 163.66 217.15 152.14"
      />
      <line className={styles.cls1} x1="217.15" y1="138.38" x2="217.15" y2="120.09" />
      <path
        className={styles.cls1}
        d="M95.01,139.08v9.61c0,1.15-.82,2.07-1.83,2.07h-5.82l-3.37,6.17-1.97-6.17h-16.84c-1.01,0-1.83-.92-1.83-2.07v-9.61c0-1.14.82-2.07,1.83-2.07h28c1.01,0,1.83.93,1.83,2.07Z"
      />
      <path
        className={styles.cls1}
        d="M190.16,183.56v9.61c0,1.14-.82,2.07-1.83,2.07h-5.82l-3.37,6.17-1.97-6.17h-16.84c-1.01,0-1.83-.93-1.83-2.07v-9.61c0-1.14.82-2.07,1.83-2.07h28c1.01,0,1.83.93,1.83,2.07Z"
      />
      <path
        className={styles.cls1}
        d="M233.91,140.45v9.61c0,1.15-.82,2.07-1.83,2.07h-5.82l-3.37,6.17-1.97-6.17h-16.84c-1.01,0-1.83-.92-1.83-2.07v-9.61c0-1.14.82-2.07,1.83-2.07h28c1.01,0,1.83.93,1.83,2.07Z"
      />
      <rect className={styles.cls1} x="66.19" y="189.82" width="7.87" height="8.15" />
      <rect className={styles.cls1} x="135.94" y="197.98" width="7.87" height="8.15" />
      <rect className={styles.cls1} x="107.02" y="130.23" width="7.87" height="8.15" />
      <rect className={styles.cls1} x="221.4" y="189.82" width="7.87" height="8.15" />
      <rect className={styles.cls2} x="35.73" y="159.43" width="20.45" height="6.61" />
      <rect className={styles.cls2} x="56.19" y="178.19" width="22.99" height="6.61" />
      <rect className={styles.cls2} x="35.73" y="196.94" width="20.45" height="6.61" />
      <polygon
        className={styles.cls2}
        points="125.17 167.89 125.17 174.51 111.76 174.51 111.76 169.43 102.18 169.43 102.18 167.89 125.17 167.89"
      />
      <rect className={styles.cls1} x="125.17" y="150.33" width="22.99" height="12.41" />
      <rect className={styles.cls2} x="183.48" y="148.35" width="10.68" height="6.61" />
      <rect className={styles.cls2} x="194.16" y="163.66" width="22.99" height="6.61" />
      <rect className={styles.cls2} x="194.16" y="178.19" width="22.99" height="6.61" />
      <rect className={styles.cls2} x="194.16" y="201.41" width="22.99" height="6.61" />
      <rect className={styles.cls2} x="148.17" y="167.89" width="22.99" height="6.61" />
      <rect className={styles.cls2} x="125.17" y="185.46" width="22.99" height="6.61" />
      <rect className={styles.cls2} x="79.18" y="201.41" width="22.99" height="6.61" />
      <g>
        <rect className={styles.cls1} x="87.12" y="169.43" width="24.64" height="25.52" />
        <line className={styles.cls1} x1="91.12" y1="177.19" x2="107.02" y2="177.19" />
        <line className={styles.cls1} x1="91.12" y1="182.22" x2="107.02" y2="182.22" />
        <line className={styles.cls1} x1="91.12" y1="187.24" x2="107.02" y2="187.24" />
      </g>
      <g>
        <rect className={styles.cls1} x="158.84" y="135.58" width="24.64" height="25.52" />
        <line className={styles.cls1} x1="162.84" y1="143.34" x2="178.74" y2="143.34" />
        <line className={styles.cls1} x1="162.84" y1="148.37" x2="178.74" y2="148.37" />
        <line className={styles.cls1} x1="162.84" y1="153.39" x2="178.74" y2="153.39" />
      </g>
      <g>
        <g>
          <path
            className={styles.cls1}
            d="M66.61,103.69c-.7,1.44-2.14,2.42-3.81,2.42-2.31,0-4.19-1.9-4.26-4.27,1.63,1.32,3.69,2.1,5.92,2.1.74,0,1.46-.08,2.15-.26Z"
          />
          <path
            className={styles.cls1}
            d="M66.43,99.36c-.61.24-1.27.37-1.97.37-1.57,0-2.99-.66-4.01-1.74.67-.47,1.48-.74,2.35-.74,1.53,0,2.88.84,3.63,2.1Z"
          />
          <path
            className={styles.cls1}
            d="M73.77,91.14h-4.36c-.95-1.82-2.81-3.06-4.95-3.06s-3.99,1.23-4.94,3.06c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78,1.16-4.2,4.89-7.26,9.31-7.26s8.15,3.07,9.31,7.26Z"
          />
        </g>
        <g>
          <path
            className={styles.cls1}
            d="M103.57,103.69c-.7,1.44-2.14,2.42-3.81,2.42-2.31,0-4.19-1.9-4.26-4.27,1.63,1.32,3.69,2.1,5.92,2.1.74,0,1.46-.08,2.15-.26Z"
          />
          <path
            className={styles.cls1}
            d="M103.39,99.36c-.61.24-1.27.37-1.97.37-1.57,0-2.99-.66-4.01-1.74.67-.47,1.48-.74,2.35-.74,1.53,0,2.88.84,3.63,2.1Z"
          />
          <path
            className={styles.cls1}
            d="M110.73,91.14h-4.36c-.95-1.82-2.81-3.06-4.95-3.06s-3.99,1.23-4.94,3.06c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78,1.16-4.2,4.89-7.26,9.31-7.26s8.15,3.07,9.31,7.26Z"
          />
        </g>
        <g>
          <path
            className={styles.cls1}
            d="M140.88,103.69c-.7,1.44-2.14,2.42-3.81,2.42-2.31,0-4.19-1.9-4.26-4.27,1.63,1.32,3.69,2.1,5.92,2.1.74,0,1.46-.08,2.15-.26Z"
          />
          <path
            className={styles.cls1}
            d="M140.7,99.36c-.61.24-1.27.37-1.97.37-1.57,0-2.99-.66-4.01-1.74.67-.47,1.48-.74,2.35-.74,1.53,0,2.88.84,3.63,2.1Z"
          />
          <path
            className={styles.cls1}
            d="M148.04,91.14h-4.36c-.95-1.82-2.81-3.06-4.95-3.06s-3.99,1.23-4.94,3.06c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78,1.16-4.2,4.89-7.26,9.31-7.26s8.15,3.07,9.31,7.26Z"
          />
        </g>
        <g>
          <path
            className={styles.cls1}
            d="M175.15,103.69c-.7,1.44-2.14,2.42-3.81,2.42-2.31,0-4.19-1.9-4.26-4.27,1.63,1.32,3.69,2.1,5.92,2.1.74,0,1.46-.08,2.15-.26Z"
          />
          <path
            className={styles.cls1}
            d="M174.97,99.36c-.61.24-1.27.37-1.97.37-1.57,0-2.99-.66-4.01-1.74.67-.47,1.48-.74,2.35-.74,1.53,0,2.88.84,3.63,2.1Z"
          />
          <path
            className={styles.cls1}
            d="M182.31,91.14h-4.36c-.95-1.82-2.81-3.06-4.95-3.06s-3.99,1.23-4.94,3.06c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78,1.16-4.2,4.89-7.26,9.31-7.26s8.15,3.07,9.31,7.26Z"
          />
        </g>
        <g>
          <path
            className={styles.cls1}
            d="M211.41,103.69c-.7,1.44-2.14,2.42-3.81,2.42-2.31,0-4.19-1.9-4.26-4.27,1.63,1.32,3.69,2.1,5.92,2.1.74,0,1.46-.08,2.15-.26Z"
          />
          <path
            className={styles.cls1}
            d="M211.23,99.36c-.61.24-1.27.37-1.97.37-1.57,0-2.99-.66-4.01-1.74.67-.47,1.48-.74,2.35-.74,1.53,0,2.88.84,3.63,2.1Z"
          />
          <path
            className={styles.cls1}
            d="M218.57,91.14h-4.36c-.95-1.82-2.81-3.06-4.95-3.06s-3.99,1.23-4.94,3.06c-.43.82-.68,1.76-.68,2.78,0,1.6.61,3.02,1.61,4.08,1.02,1.08,2.44,1.74,4.01,1.74.7,0,1.36-.13,1.97-.37.41.67.65,1.47.65,2.33,0,.71-.17,1.4-.47,2-.69.18-1.41.26-2.15.26-2.23,0-4.29-.79-5.92-2.1-2.29-1.82-3.77-4.7-3.77-7.93,0-.96.13-1.9.38-2.78,1.16-4.2,4.89-7.26,9.31-7.26s8.15,3.07,9.31,7.26Z"
          />
        </g>
      </g>
      <polyline
        className={styles.cls1}
        points="237.61 220.3 245.87 218.54 245.32 210.31 237.61 95.13"
      />
      <polyline className={styles.cls1} points="237.61 93.18 249.78 208.03 245.24 208.03" />
      <path
        className={styles.cls2}
        d="M260,227.95c-2.73,2.52-10.76,10.5-26.42,14.21-15.65,3.7-18.89-3.18-49.02,0-16.34,1.72-70.34,3.54-105.38-1.45-29.54-4.2-39.14-15.23-39.14-15.23h197.57v-5.18l8.26-1.76-.66-9.86c9.76-.41,15.95,1.05,16.41,1.27,2.66,1.23,4.93,11.96-1.62,18Z"
      />
      <line className={styles.cls1} x1="232.58" y1="73.75" x2="239.39" y2="56.05" />
      <line className={styles.cls1} x1="237.61" y1="76.47" x2="249.78" y2="70.17" />
      <line className={styles.cls1} x1="225.26" y1="73.32" x2="224.58" y2="63.88" />
    </svg>
  );
}
